<template>
<w-map-popup :titleVisible="false">
  <div :class="$style.main">
    <div :class="$style.header" class="minimap-popup-header">
      <i :class="$style.close" class="el-icon-close" @click="onCloseClick"></i>
    </div>
    <div id="overview" :class="$style.view"></div>
  </div>
</w-map-popup>
</template>

<script>
import MapConst from '@/constants/topologymap';

import WMapPopup from '@/views/topologymap/components/MapPopup';
import { Q, MapInfo, MapPopup } from '@/views/topologymap/js/maps';

export default {
  name: 'WMinimapWindow',
  components: {
    WMapPopup,
  },
  data() {
    return {
      MapConst,
      /**
       * 팝업 속성
       * @type {Object}
       */
      config: {
        type: MapConst.POPUP_TYPE.WINDOW,
        x: window.innerWidth - 300,
        y: 95,
        width: 200,
        height: 150,
        minWidth: 200,
        minHeight: 150,
        clickToClose: false,
        scrollable: false,
        resizable: false,
        draggable: '.minimap-popup-header',
      },
      events: {
        /**
         * 팝업창 오픈 콜백
         * @author KangBonghun(toto1323)
         * @return {[type]} [description]
         */
        opened: () => {
          // 미니맵 invalidate
          // const overview = MapInfo.getInstance(this).getGraph().overview;
          // if (overview.invalidateGraph2) {
          //   overview.invalidateGraph2(true);
          // }
        },
      },
    };
  },
  methods: {
    /**
     * 닫기 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onCloseClick() {
      MapPopup.closeAndHide(this.$options.name);
    },
  },
  mounted() {
    const graph = MapInfo.getInstance(this).getGraph();
    const overview = new Q.Overview(document.getElementById('overview')); // 미니맵 생성
    overview.setVisible(true);
    overview.setGraph(graph);
    graph.overview = overview;
  },
};
</script>

<style module>
.main {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 3px;
}

.header {
  height: 15px;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  cursor: move;
}

.view {
  width: 100%;
  height: 100%;
}

.close {
  position: absolute;
  top: 3px;
  right: 7px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/monitoring/MinimapWindow.vue